import dayjs from 'dayjs'
import React from 'react'
import {
  AlertCircle, ChevronsRight, X, XCircle,
} from 'react-feather'
import { formatDifferenceFromNow } from 'src/utils/formatDifference'
import BoltIcon from '@mui/icons-material/Bolt'
import { Tooltip } from '@mui/material'
import * as S from './QueueTab.styles'

const checkReceivementIssueIcon = (hasCancelled, issue, order) => {
  if (hasCancelled) {
    return (
      <>
        <XCircle
          aria-label='Atenção'
          style={{
            height: '25px',
            width: '25px',
            color: 'black',
          }}
        />
        {order}
      </>
    )
  }

  if (issue) {
    return (
      <>
        <AlertCircle
          aria-label='Atenção'
          style={{
            height: '25px',
            width: '25px',
            color: 'yellow',
          }}
        />
        {order}
      </>
    )
  }
  return order
}

const checkReceivementIssue = (hasCanceledArs, issue, supplier) => {
  if (hasCanceledArs) {
    return `${supplier} - Nota fiscal cancelada!`
  }

  if (issue) {
    return `${supplier} - Existem pendências!`
  }

  return supplier
}

export const createRowData = (
  receivement,
  setQueueRow,
  setOpenModalChangePosition,
  setOpenModalRemoveProviderQueue,
) => {
  const receivementDate = dayjs(receivement.recebimento.data_inclusao)

  const isExpress = receivement.recebimento.is_express && (
    <Tooltip
      placement='top'
      title='Recebimento expresso'
      arrow
    >
      <BoltIcon
        sx={{ color: '#ff0000' }}
        data-testid='is-express-icon-test-id'
      />
    </Tooltip>
  )

  return {
    hasIssue: receivement.recebimento.hasIssue,
    position: checkReceivementIssueIcon(
      receivement.recebimento.has_canceled_ars,
      receivement.recebimento.hasIssue,
      receivement.ordem,
    ),
    supplier: checkReceivementIssue(
      receivement.recebimento.has_canceled_ars,
      receivement.recebimento.hasIssue,
      receivement.recebimento.fornecedor.nm_fornecedor,
    ),
    password: (<>{receivement.recebimento.senha_atendimento}{isExpress}</>),
    issues: receivement.recebimento?.swap_return_types?.length > 0 ? receivement.recebimento.swap_return_types.join(', ') : '',
    arrival: receivementDate.format('DD/MM/YYYY HH:mm'),
    waitTime: formatDifferenceFromNow(receivementDate),
    invoiceNumbers: receivement.recebimento.invoice_numbers,
    actions: (
      <S.Action>
        <ChevronsRight
          onClick={() => {
            setOpenModalChangePosition(true)
            setQueueRow({
              receivement_id: receivement.id_recebimento,
              position: receivement.ordem,
              supplier: receivement.recebimento.fornecedor.nm_fornecedor,
            })
          }}
          aria-label='Alterar a ordem'
          style={{ height: '25px', width: '25px', cursor: 'pointer' }}
        />
        <X
          onClick={() => {
            setOpenModalRemoveProviderQueue(true)
            setQueueRow({
              receivement_id: receivement.id_recebimento,
              position: receivement.ordem,
              supplier: receivement.recebimento.fornecedor.nm_fornecedor,
            })
          }}
          aria-label='Cancelar recebimento'
          style={{ height: '25px', width: '25px', cursor: 'pointer' }}
        />
      </S.Action>
    ),
  }
}
